const bountyActionTypes = {
    FETCH_BOUNTIES_START: 'FETCH_BOUNTIES_START',
    FETCH_BOUNTIES_SUCCESS: 'FETCH_BOUNTIES_SUCCESS',
    FETCH_BOUNTIES_FAILURE: 'FETCH_BOUNTIES_FAILURE',
    CLAIM_BOUNTY_START: 'CLAIM_BOUNTY_START',
    CLAIM_BOUNTY_SUCCESS: 'CLAIM_BOUNTY_SUCCESS',
    CLAIM_BOUNTY_FAILURE: 'CLAIM_BOUNTY_FAILURE'
};

export default bountyActionTypes;
